/**
 * Perfis autorizados a acessar o módulo de oportunidades de contratação
 * (alinhado ao backend: admin, gerente e analista).
 */
export const OPPORTUNITY_MANAGER_ROLES: readonly string[] = ['admin', 'gerente', 'analista'];

export function userCanManageOpportunities(role: string | undefined | null): boolean {
  return role != null && role !== '' && OPPORTUNITY_MANAGER_ROLES.includes(role);
}

type UserLikeForPurchaseTabs = {
  role?: string | null;
  can_access_purchase_tabs?: boolean | null;
} | null | undefined;

export function userCanAccessPurchaseTabs(user: UserLikeForPurchaseTabs): boolean {
  if (!user) return false;
  if (user.role === 'admin' || user.role === 'gerente') return true;
  return !!user.can_access_purchase_tabs;
}
